import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import theme from './theme';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { AuthProvider } from "react-oidc-context";
import config from './config';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading... </div>} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <AuthProvider {...config.cognitoAuthConfig}>
          <CssBaseline />
          <App />
        </AuthProvider>
      </ThemeProvider>
    </PersistGate>
  </Provider>,
);
